<template>
<div class="chapter">
<div class="inner_page">
<div id="a05_ded">
<a id="page_6">
<p class="dedication"><i>To the officers and men of Charlie Company, First Corps Medium <br/>Tank Battalion and their families, and to Christiane.</i></p>
</a></div><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_ded.vue?05fd6028